<script lang="ts" setup>
import { useField } from 'vee-validate';
import BaseInput from './_base.vue';
import Toggle from '@vueform/toggle';

interface Props {
  name: string;
  label: string;
  type: 'toggle' | 'checkbox';
}

const props = withDefaults(defineProps<Props>(), {
  name: undefined,
  label: undefined,
  type: 'checkbox',
});

const { value: inputValue, errorMessage, handleBlur, handleChange, meta } = useField(props.name, undefined, { initialValue: false });
</script>

<template>
  <BaseInput :errorMessage="errorMessage" :meta="meta" :name="name" :label="label" labelPosition="left">
    <Toggle v-model="inputValue" @change="meta.touched = true" class="mb-[8px]"></Toggle>
  </BaseInput>
</template>
